import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=219e0d7c&scoped=true&"
import script from "./OrderProduct.vue?vue&type=script&lang=js&"
export * from "./OrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderProduct.vue?vue&type=style&index=0&id=219e0d7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e0d7c",
  null
  
)

export default component.exports